import FadeContainer from './fade-container'

export default FadeContainer
